const state = {
  isLoadingUpdateMultipleMandatesLastSeen: false,

  showLoaderOverlay: false,

  // Syncing indicators
  showSyncLoading: false,
  showSyncLoadingSuccess: false,
  showSyncLoadingError: false,

  isConnected: false,
  importBuildingOwners: undefined,
};

export default state;
